module.exports = __webpack_public_path__ + "img/video-process.72df76ab.png";